<template>
  <div class="dashboard-container">
    <el-card shadow="hover">
      <div class="dashboard-title">首页概况</div>
      <!-- <div class="dashboard-text">name: {{ name }}</div> -->
      <el-divider />
      <div class="dashboard-container-text-descriptions">
        <div
          v-for="(item, index) in infoList"
          :key="item.title"
          class="description-row"
        >
          <div class="description-row-column">
            <div class="title">{{ item.title }}</div>
            <div class="total-num" :style="{ color: numColorMap[index] }">
              {{ item.num }}
            </div>
            <div v-if="item.compare" class="yesterday-row">
              <div class="yesterday-title">
                {{ item.compare.subTitle ? item.compare.subTitle + ":" : "" }}
              </div>
              <div class="yesterday-count">{{ item.compare.subNum || "" }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
    <div class="user-reg-statistics">
      <el-card shadow="never" body-style="{border:none}">
        <div style="width: 100%; height: 450px; margin-left: -10px">
          <v-chart ref="chartRef" :options="lineOptions" />
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { pluck, equals } from 'ramda'
import { getDashboard, getUserRegStatistics } from '@/api/dashboard'
import dayjs from 'dayjs'
import { numColorMap } from './const'
export default {
  name: 'Dashboard',
  components: {},
  data() {
    return {
      numColorMap,
      lineOptions: {},
      infoList: [],
      loading: false,
      currMonth: dayjs().format('YYYY-MM')
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    /**
     * 请求接口获取数据
     */
    async fetchData() {
      const { data } = await getDashboard()
      this.infoList = data
      const userData = await getUserRegStatistics({
        days: 30,
        endDate: dayjs().format('YYYY-MM-DD')
      })
      this.lineOptions = this._genLineOptions(userData.data)
    },
    /**
     * 私有方法，辅助fetchData生成折线图配置
     */
    _genLineOptions(content) {
      return {
        title: {
          text: `用户注册数量  (${this.currMonth})`,
          left: 'center',
          textStyle: {
            color: 'rgba(16, 16, 16, .7)',
            fontSize: 12
          }
        },
        tooltip: {
          trigger: 'item',
          // formatter: '{b0}<br /> 注册用户数量: {c0} '
          formatter: (params) => {
            let dayStr = params.name || ''
            if (equals(1, dayStr.length)) {
              dayStr = dayStr.padStart(2, '0')
            }
            // return `${
            //   dayjs().format("YYYY-MM") + "-" + dayStr
            // }<br/> 注册用户数量: ${params.value || 0}`;
            return `${dayStr}<br/> 注册用户数量: ${params.value || 0}`
          }
        },
        color: '#53B095',
        yAxis: {},
        xAxis: {
          type: 'category',
          data: pluck('date')(content)
        },
        series: [
          {
            type: 'line',
            smooth: true,
            data: pluck('regNum')(content)
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.echarts {
  width: 90%;
  height: 90%;
}
.dashboard {
  &-container {
    margin: 10px;
    margin-top: 35px;
    &-text-descriptions {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-left: 63px;
      margin-top: -10px;
      .description-row {
        display: flex;
        width: 100px;
        flex-direction: column;
        margin-right: 15%;
        margin-top: 20px;
        &-column {
          .title {
            font-size: 15px;
            margin-top: 9px;
          }
          .total-num {
            margin-top: 9px;
          }
          .yesterday-row {
            font-size: 12px;
            margin-top: 9px;
            color: rgba(16, 16, 16, 0.52);
            display: flex;
            .yesterday-title {
              min-width: 30px;
            }
            .yesterday-count {
              margin-left: 5px;
            }
          }
        }
      }
    }
    .user-reg-statistics {
      width: 100%;
      height: 500px;
      margin-top: 20px;
    }
  }
  &-title {
    font-size: 20px;
    margin-left: 63px;
    margin-top: 10px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
</style>
